import React from 'react';
import Families from './Families';
import PanelInfo from '../../labels/PanelInfo';

// eslint-disable-next-line
import style from './_styles.css';

class Index extends React.Component {
    render() {
        const { param } = this.props;
        return (
            <div className={'flex_full_row bg_ice_blue'}>
                <div className={'flex_50 overflow_y_scroll padding_top_12 shadow_right_only'}>
                    <Families param={param} />
                </div>
                <PanelInfo
                    is50={true}
                    id={
                        param === undefined
                            ? 'families_aux_message_primary'
                            : 'families_aux_message'
                    }
                />
            </div>
        );
    }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/complex/families/Index.js